import React, { useEffect, useState, useContext } from 'react';
import { AiOutlineCheck } from 'react-icons/ai';
import axios from "axios";
import { BASELINE } from "../../util";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { UserContext } from "../../context/UserContext";

// Assuming FilterButton has been imported or defined in the same file
const FilterButton = ({ label, isActive, onClick }) => {
    return (
        <button
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium border transition-all ${
                isActive
                    ? 'bg-blue-600 text-white border-blue-600'
                    : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'
            }`}
            onClick={onClick}
        >
            {isActive && <AiOutlineCheck className="text-sm" />}
            <span>{label}</span>
        </button>
    );
};

const ModalComponent = ({ topic, isOpen, onClose, section, type }) => {
    const { user } = useContext(UserContext);

    const [tutorMode, setTutorMode] = useState(false);
    const [timerMode, setTimerMode] = useState(false);
    const [timeInMinutes, setTimeInMinutes] = useState(0);
    const [difficulty, setDifficulty] = useState({
        E: false,
        M: false,
        H: false
    });
    const [numberOfQuestions, setNumberOfQuestions] = useState(0);
    const [groupedQuestions, setGroupedQuestions] = useState({ E: [], M: [], H: [] });
    const [st, setst] = useState(false);
    const [total, settotal] = useState(0);
    const [combined, setcombined] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        let newCombined = [];

        // Recalculate total when difficulty changes
        const newTotal = Object.keys(difficulty).reduce((sum, key) => {
            if (difficulty[key]) {
                // Combine the arrays when the difficulty is toggled on
                newCombined = [...newCombined, ...groupedQuestions[key]];
            }
            const count = groupedQuestions[key].length;
            return difficulty[key] ? sum + count : sum;
        }, 0);
        setcombined(newCombined); // Set the combined array state
        settotal(newTotal); // Set the total state

    }, [difficulty]);

    useEffect(() => {
        if (!isOpen) return; // Only fetch when the modal is open

        if (section === 'ACT') {
            axios.get(BASELINE + "get/amount/bytopic/act", {
                params: { topic }
            })
                .then(response => {
                    settotal(response.data.length);
                    setcombined(response.data);
                    setst(true);
                })
                .catch(err => {
                    console.error("Error fetching SAT question data:", err);
                });
        } else if (section === 'Apcalcab') {
            axios.get(BASELINE + "get/amount/bytopic/apcalcab", {
                params: { topic }
            })
                .then(response => {
                    settotal(response.data.length);
                    setcombined(response.data);
                    setst(true);
                })
                .catch(err => {
                    console.error("Error fetching SAT question data:", err);
                });
        } else {
            if (type === 'SAT10') {
                axios.get(BASELINE + "get/amount/bytopic/10", {
                    params: { topic }
                })
                    .then(response => {
                        const grouped = response.data.reduce((acc, question) => {
                            const difficulty = question.difficultys;
                            if (!acc[difficulty]) {
                                acc[difficulty] = [];
                            }
                            acc[difficulty].push(question);
                            return acc;
                        }, { E: [], M: [], H: [] });
                        setGroupedQuestions(grouped);
                        setst(true);
                    })
                    .catch(err => {
                        console.error("Error fetching SAT question data:", err);
                    });
            } else if (type === 'SAT89') {
                axios.get(BASELINE + "get/amount/bytopic/89", {
                    params: { topic }
                })
                    .then(response => {
                        const grouped = response.data.reduce((acc, question) => {
                            const difficulty = question.difficultys;
                            if (!acc[difficulty]) {
                                acc[difficulty] = [];
                            }
                            acc[difficulty].push(question);
                            return acc;
                        }, { E: [], M: [], H: [] });
                        setGroupedQuestions(grouped);
                        setst(true);
                    })
                    .catch(err => {
                        console.error("Error fetching SAT question data:", err);
                    });
            } else {
                axios.get(BASELINE + "get/amount/bytopic", {
                    params: { topic }
                })
                    .then(response => {
                        const grouped = response.data.reduce((acc, question) => {
                            const difficulty = question.difficultys;
                            if (!acc[difficulty]) {
                                acc[difficulty] = [];
                            }
                            acc[difficulty].push(question);
                            return acc;
                        }, { E: [], M: [], H: [] });
                        setGroupedQuestions(grouped);
                        setst(true);
                    })
                    .catch(err => {
                        console.error("Error fetching SAT question data:", err);
                    });
            }
        }
    }, [topic, isOpen]); // Added isOpen here

    const handleToggle = (key) => {
        if (key === 'tutorMode') {
            setTutorMode(!tutorMode);
        } else if (key === 'timerMode') {
            setTimerMode(!timerMode);
        } else {
            setDifficulty(prev => ({ ...prev, [key]: !prev[key] }));
        }
    };

    const handleStart = () => {
        // combined 배열에서 numberOfQuestions 수만큼 랜덤으로 questionIds를 선택
        const getRandomQuestionIds = (combinedArray, numberOfQuestions) => {
            const shuffled = [...combinedArray].sort(() => 0.5 - Math.random());
            const selected = shuffled.slice(0, numberOfQuestions);
            return selected.map(item => item.questionIds);
        };

        const getRandomQuestionIdsACT = (combinedArray, numberOfQuestions) => {
            // Shuffle the combinedArray
            const shuffledArray = combinedArray.sort(() => 0.5 - Math.random());

            // Select the first `numberOfQuestions` items
            const selectedQuestions = shuffledArray.slice(0, numberOfQuestions);

            // Extract the qid from the selected questions
            const questionIds = selectedQuestions.map(question => question.qid);

            // Return the array of qid
            return questionIds;
        };

        const getRandomQuestionIdsAP = (combinedArray, numberOfQuestions) => {
            // Shuffle the combinedArray
            const shuffledArray = combinedArray.sort(() => 0.5 - Math.random());
            // Select the first `numberOfQuestions` items
            const selectedQuestions = shuffledArray.slice(0, numberOfQuestions);
            // Extract the qid from the selected questions
            const questionIds = selectedQuestions.map(question => question.question_id);

            // Return the array of qid
            return questionIds;
        };

        if (numberOfQuestions <= 0) {
            toast.error("Please enter a valid number of questions greater than 0.");
            return;
        }

        if (numberOfQuestions > total) {
            toast.error(`The number of questions exceeds the available questions. Maximum available questions are ${combined.length}.`);
            return;
        }
        let selectedQuestionIds;

        if (section === 'ACT') {
            selectedQuestionIds = getRandomQuestionIdsACT(combined, numberOfQuestions);
        } else if (section === 'Apcalcab') {
            selectedQuestionIds = getRandomQuestionIdsAP(combined, numberOfQuestions);
        } else {
            selectedQuestionIds = getRandomQuestionIds(combined, numberOfQuestions);
        }

        let quizData = {
            questionIds: selectedQuestionIds,
            tutorModeActive: tutorMode,
            timedModeActive: timerMode,
            timeLimit: timerMode ? timeInMinutes : null,
            tag: section,
            type: type
        };

        if (section === 'ACT') {
            navigate(`/act/quiz/`, { state: { data: quizData } });
        } else if (section === 'Apcalcab') {
            quizData.tag = 'MCQ'
            navigate(`/ap/quiz/`, { state: { data: quizData } });
        } else {
            navigate(`/sat/quiz/`, { state: { data: quizData } });
        }
    };

    const handleClose = () => {
        // Reset all states to default values
        setTutorMode(false);
        setTimerMode(false);
        setTimeInMinutes(0);
        setDifficulty({ E: false, M: false, H: false });
        setNumberOfQuestions(0);
        settotal(0);
        setcombined([]);
        setGroupedQuestions({ E: [], M: [], H: [] });

        // Close the modal
        onClose(false);
    };

    return (
<div className={`fixed inset-0 flex items-center justify-center z-50 ${isOpen ? "" : "hidden"}`}>
  <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={handleClose} />

  <div className="relative bg-white border border-slate-200 shadow-2xl rounded-2xl p-6 w-[90%] sm:w-[70%] md:w-[50%] lg:w-[38%] max-h-[90%] overflow-auto">
    {/* Close */}
    <button className="absolute top-4 right-4 w-7 h-7 flex items-center justify-center rounded-full bg-slate-100 hover:bg-slate-200 text-slate-500 hover:text-slate-700 transition-colors" onClick={handleClose}>
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
      </svg>
    </button>

    {/* Header */}
    <div className="mb-5 pr-6">
      <h2 className="text-xl font-bold text-slate-900">Setup Quick Test</h2>
      <p className="mt-1 text-sm text-slate-500">Topic: <span className="font-semibold text-slate-700">{topic}</span></p>
    </div>

    {/* Test Settings */}
    <div className="mb-4">
      <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2">Test Settings</p>
      <div className="flex gap-2 flex-wrap">
        <FilterButton label="AI Support" isActive={tutorMode} onClick={() => handleToggle("tutorMode")} />
        <FilterButton label="Timer Mode" isActive={timerMode} onClick={() => handleToggle("timerMode")} />
        {timerMode && (
          <div className="flex items-center gap-2">
            <input
              type="number"
              value={timeInMinutes}
              onChange={(e) => setTimeInMinutes(e.target.value)}
              placeholder="Time"
              className="border border-slate-200 bg-slate-50 text-slate-800 p-1.5 rounded-lg w-16 text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <span className="text-sm text-slate-500">min</span>
          </div>
        )}
      </div>
    </div>

    {/* Difficulty */}
    {st === true && section !== "ACT" && section !== "Apcalcab" && (
      <div className="mb-4">
        <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2">Difficulty Level</p>
        <div className="flex gap-2 flex-wrap">
          <FilterButton label={`Easy (${groupedQuestions.E.length})`} isActive={difficulty.E} onClick={() => handleToggle("E")} />
          <FilterButton label={`Medium (${groupedQuestions.M.length})`} isActive={difficulty.M} onClick={() => handleToggle("M")} />
          <FilterButton label={`Hard (${groupedQuestions.H.length})`} isActive={difficulty.H} onClick={() => handleToggle("H")} />
        </div>
      </div>
    )}

    {/* Number of Questions */}
    <div className="mb-6">
      <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2">Number of Questions</p>
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2">
          <input
            type="number"
            value={numberOfQuestions}
            onChange={(e) => {
              const value = e.target.value;
              if (!isNaN(value) && Number(value) >= 0) setNumberOfQuestions(Number(value));
            }}
            min="0"
            className="border border-slate-200 bg-slate-50 text-slate-800 p-1.5 rounded-lg w-20 text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <span className="text-sm text-slate-400 cursor-pointer hover:text-blue-600 transition-colors" onClick={() => setNumberOfQuestions(total)}>
            / {total}
          </span>
        </div>
        <div className="flex gap-1.5">
          {[5, 10].map(n => (
            <button key={n} onClick={() => setNumberOfQuestions(n)}
              className="px-3 py-1 bg-slate-100 hover:bg-slate-200 text-slate-600 text-sm rounded-lg transition-colors font-medium">
              {n}
            </button>
          ))}
          <button onClick={() => setNumberOfQuestions(total)}
            className="px-3 py-1 bg-slate-100 hover:bg-slate-200 text-slate-600 text-sm rounded-lg transition-colors font-medium">
            All
          </button>
        </div>
      </div>
    </div>

    {/* Start */}
    <button
      className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold py-2.5 px-4 rounded-xl transition-colors shadow-sm"
      onClick={handleStart}
    >
      Start Test
    </button>
  </div>
</div>
    );
};

export default ModalComponent;